export default "__VITE_ASSET__DQsz7Ca3__"